import styled from 'styled-components'

export const Container = styled.div`
  flex: row;
  flex: 1;
`
